export const SYSTEM_PROTOTYPES_QUERY_KEY = 'system-prototypes';
